export default __webpack_public_path__ + "3abd16dff3fa3628edde8d94135df95a.png";